import { QueryClient, QueryFilters } from "@tanstack/react-query";

export type IQueryCacheStoreInit = {
    queryClient?: QueryClient
    queryStaleTime?: number
}

export class QueryCacheStore {
    queryClient?: QueryClient;
    queryStaleTime?: number;

    constructor(init?: IQueryCacheStoreInit) {
        this.queryClient = init?.queryClient;
        this.queryStaleTime = init?.queryStaleTime;
    }

    /**
     * Clears cached queries that match the queryKey parameter
     * @param queryKey QueryFilters object that will be used to find queries to clear, e.g. { queryKey: [HospitalService.tags.getHospitalSchedules, { hospitalId, date: startDateString, range: HospitalScheduleDateRangeType.Day }], exact: true }
     */
    clearCache(queryKey: QueryFilters) {
        this.queryClient?.removeQueries(queryKey);
    }
}
